import React from 'react';
import Dialog from '@mui/material/Dialog';
import styles from './ai-dialog-shared/AiDialog.module.css';
import { useProductDescriptionAiDialog } from './product-description-ai-dialog/useProductDescriptionAiDialog';
import { DialogHeader } from './ai-dialog-shared/components/DialogHeader';
import { ContextDescription } from './ai-dialog-shared/components/ContextDescription';
import { PromptEditor } from './ai-dialog-shared/components/PromptEditor';
import { QuickPromptStyles } from './ai-dialog-shared/components/QuickPromptStyles';
import { SuggestionsArea } from './ai-dialog-shared/components/SuggestionsArea';
import { DialogFooter } from './ai-dialog-shared/components/DialogFooter';

const ProductDescriptionAiDialog = (props) => {
  const {
    openProductDescripDialog,
    setOpenProductDescripDialog,
    setDescription,
    title = '',
    productCategory = 'select',
    cuisineType = '',
  } = props;

  const {
    hasCategory,
    hasCuisine,
    predefinedPrompts,
    activePrompt,
    setActivePrompt,
    chosenDescription,
    isLoading,
    suggestions,
    errorMessage,
    chatResponseText,
    chatSuggestions,
    handleClose,
    handleSelectPrompt,
    handleGenerateDescriptions,
    handleChooseSuggestion,
    handleSelectDescription,
  } = useProductDescriptionAiDialog({
    setOpenProductDescripDialog,
    setDescription,
    title,
    productCategory,
    cuisineType,
  });

  return (
    <Dialog
      open={openProductDescripDialog}
      className='alert-dialog-wrapper ai-product-description-dialog'
      maxWidth='md'
      // fullWidth
    >
      <div className={styles.body}>
        <DialogHeader title='AI Product Description Assistant' onClose={handleClose} />

        <ContextDescription
          introText='Craft a clear, appetizing description for your menu item. You can fine-tune the prompt or pick one of the quick styles below. We use your current product title'
          trailingText='for better results.'
          hasCategory={hasCategory}
          hasCuisine={hasCuisine}
          productCategory={productCategory}
          cuisineType={cuisineType}
        />

        <PromptEditor
          activePrompt={activePrompt}
          setActivePrompt={setActivePrompt}
          isLoading={isLoading}
          errorMessage={errorMessage}
          onGenerate={handleGenerateDescriptions}
          generateButtonLabel='Generate descriptions'
        />

        <QuickPromptStyles
          predefinedPrompts={predefinedPrompts}
          activePrompt={activePrompt}
          onSelectPrompt={handleSelectPrompt}
        />

        <SuggestionsArea
          isLoading={isLoading}
          chatResponseText={chatResponseText}
          chatSuggestions={chatSuggestions}
          selectedValue={chosenDescription}
          onChooseSuggestion={handleChooseSuggestion}
        />

        <DialogFooter
          selectedValue={chosenDescription}
          suggestions={suggestions}
          onClose={handleClose}
          onSelect={handleSelectDescription}
          selectButtonLabel='Select description'
        />
      </div>
    </Dialog>
  );
};

export default ProductDescriptionAiDialog;
